export default class SelectDocumentTemplateModalController {

    constructor($scope, $uibModalInstance, relationType, $injector) {
        this.scope = $scope;
        this.modalInstance = $uibModalInstance;
        this.relationType = relationType;
        this.injector = $injector;
        this.api = $injector.get('$http');
        this.translate = $injector.get('$translate');

        this.selectedTemplate = null;
        this.selectedTemplateModel = null;
        this.templatesSelectConfig = null;
        this.validTemplateIsSelected = false;

        this._resetError();
        this._prepareTemplatesSelectConfig();
        this._initWatchers();
    }

    selectTemplate() {
        this.modalInstance.close({
            templateId: this.selectedTemplate
        });
    }

    dismiss() {
        this.modalInstance.dismiss();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.selectedTemplate;
        }, () => {
            this.validTemplateIsSelected = false;
            this.selectedTemplateModel = null;
            if (this.selectedTemplate) {
                this.api.get(`documents/templates/${this.selectedTemplate}`).then((response) => {
                    this.selectedTemplateModel = response.data.data;
                    this.validTemplateIsSelected = true;
                    this._refreshScope();
                }, () => {
                    this._setError(this.translate.instant('documents.modals.select-template.errors.error_loading_template'));
                    this._refreshScope();
                })
            }
        })
    }

    _prepareTemplatesSelectConfig() {
        const store = this.injector.get('DocumentTemplates').reset({
            persist: false,
            listview: 'CreateDocumentsSelectTemplateListView'
        });

        store.commit('setPermanentFilters', {
            relation_type: this.relationType
        });

        this.templatesSelectConfig = {
            store,
            displayField: 'title',
            valueField: 'id'
        };
    }

    _refreshScope() {
        this.scope.$applyAsync();
    }

    _resetError() {
        this.error = {
            state: false,
            message: ''
        };
    }

    _setError(message) {
        this.error = {
            state: true,
            message: message
        };
    }
}

SelectDocumentTemplateModalController.$inject = [
    '$scope',
    '$uibModalInstance',
    'relationType',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/documents/controllers/modals/select-template-modal-controller.js